export enum HttpCodes {
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  NO_CONTENT = 204,
  MULTI_STATUS = 207,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
  CONFLICT = 409,
  FORCE_RELOGIN = 419,
  SERVER_ERROR = 500,
  MAINTENANCE = 503,
  TIMEOUT = 504,
}
